interface Props {
  campaignId: number | undefined;
  isReadOnly: boolean;
}

export default function PageTitle({ campaignId, isReadOnly }: Props) {
  if (isReadOnly) {
    return 'Promotion Details';
  }

  return campaignId ? 'Edit Promotion' : 'Schedule Promotion';
}
